<template>
    <section class="odocs-spaced">
        <p>
            <o-tag>Tag label</o-tag>
            <o-tag label="Rounded tag label" rounded />
            <o-tag icon="plus">Tag with icon</o-tag>
        </p>
    </section>
</template>
